var _rect, _g, _path, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyXlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 48099499"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5272",
    width: 100.235,
    height: 100.235,
    fill: "#161103"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 48099061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3462_10814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 17,
    width: 82,
    height: 66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 48099058"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48099056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 913",
    d: "M50.2041 26.8799L42.4432 19.1381C40.8625 17.5613 38.3039 17.5613 36.7233 19.1381L10.605 45.1921C9.01483 46.7783 9.01939 49.3556 10.6151 50.9362L26.1035 66.2777C27.6852 67.8443 30.2351 67.8398 31.8113 66.2676L39.021 59.0755C39.3345 58.7628 39.3436 58.2579 39.0416 57.9341L30.0945 48.343C29.7956 48.0226 29.8009 47.5241 30.1065 47.2101L39.0034 38.0702C39.3225 37.7424 39.8479 37.7386 40.1717 38.0616L49.6242 47.4908C49.9447 47.8105 50.4635 47.8105 50.784 47.4908L60.245 38.053C60.5655 37.7333 61.0843 37.7333 61.4048 38.053L70.5761 47.2017C70.8929 47.5177 70.8983 48.0292 70.5883 48.3519L61.3792 57.9377C61.0708 58.2588 61.0744 58.7672 61.3874 59.0838L68.4262 66.2056C70.0074 67.8055 72.5895 67.8101 74.1765 66.2158L89.5344 50.787C91.111 49.2031 91.1065 46.6415 89.5243 45.0631L63.5556 19.1584C61.967 17.5737 59.3928 17.5828 57.8155 19.1787L50.2041 26.8799Z",
    fill: "#F5ECCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5269",
    d: "M40.3118 74.2166C39.9907 73.8964 39.9907 73.3771 40.3118 73.0568L49.7267 63.6651C50.0478 63.3448 50.5683 63.3448 50.8894 63.6651L60.3043 73.0568C60.6253 73.3771 60.6253 73.8964 60.3043 74.2166L53.5846 80.9197C51.775 82.7249 48.8411 82.7249 47.0315 80.9197L40.3118 74.2166Z",
    fill: "#F5ECCD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3462_10814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 17,
    width: 81,
    height: 53
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 914",
    d: "M50.2054 26.8799L42.6861 19.3166C41.0961 17.7174 38.5061 17.725 36.9257 19.3336L11.1803 45.5367C9.61959 47.1252 9.63431 49.6758 11.2133 51.2461L29.3884 69.3222L39.5846 58.5147L29.562 47.7708L39.5846 37.4746L50.2054 48.0693L60.8263 37.4746L71.1479 47.7708L61.9349 57.3607C61.318 58.0029 61.3252 59.0196 61.9512 59.6529L68.4275 66.2056C70.0088 67.8055 72.5909 67.8101 74.1778 66.2159L89.5358 50.787C91.1124 49.2031 91.1079 46.6415 89.5257 45.0631L63.557 19.1584C61.9684 17.5737 59.3941 17.5828 57.8168 19.1787L50.2054 26.8799Z",
    fill: "#F5ECCD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3462_10814)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3462_10814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 48099057"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    x: 50.2656,
    y: 53.3047,
    width: 67.2235,
    height: 63.8198,
    fill: "#DA745D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: -16.957,
    y: -10.5156,
    width: 67.2235,
    height: 63.8198,
    fill: "#D4B5F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5",
    d: "M-16.957 53.3047H50.2665V117.124H-16.957V53.3047Z",
    fill: "#F3D565"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 50.2656,
    y: -10.5156,
    width: 67.2235,
    height: 63.8198,
    fill: "#9FB6D6"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 48099060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 913_2",
    d: "M50.182 29.9857L43.541 23.361C42.1203 21.9439 39.8207 21.9439 38.4 23.361L15.9283 45.7774C14.4991 47.2031 14.5032 49.5196 15.9374 50.9402L29.1894 64.0665C30.611 65.4746 32.9029 65.4706 34.3195 64.0574L40.4652 57.9269C40.7469 57.6458 40.7551 57.1919 40.4836 56.9009L32.7576 48.6188C32.489 48.3309 32.4938 47.8828 32.7685 47.6006L40.4494 39.7099C40.7361 39.4153 41.2083 39.4118 41.4994 39.7022L49.6608 47.8435C49.9488 48.1308 50.4151 48.1308 50.7032 47.8435L58.8723 39.6945C59.1604 39.4071 59.6266 39.4071 59.9147 39.6945L67.8328 47.5931C68.1175 47.8771 68.1224 48.3368 67.8438 48.6268L59.8917 56.9042C59.6145 57.1928 59.6177 57.6497 59.899 57.9343L65.8958 64.0017C67.317 65.4397 69.6377 65.4438 71.064 64.0109L84.2036 50.8108C85.6206 49.3872 85.6166 47.0848 84.1945 45.6662L61.8525 23.3793C60.4247 21.955 58.111 21.9632 56.6934 23.3976L50.182 29.9857Z",
    fill: "#F5ECCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5269_2",
    d: "M41.6202 70.8376C41.3316 70.5498 41.3316 70.0831 41.6202 69.7952L49.7491 61.6862C50.0377 61.3984 50.5056 61.3984 50.7941 61.6862L58.9231 69.7952C59.2117 70.0831 59.2117 70.5498 58.9231 70.8376L53.2166 76.5301C51.5901 78.1526 48.9531 78.1526 47.3267 76.5301L41.6202 70.8376Z",
    fill: "#F5ECCD"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyXlogo);
export default __webpack_public_path__ + "static/media/moneyXlogo.7c9fd52692e500ada4ab6880853f2f6c.svg";
export { ForwardRef as ReactComponent };